interface Payload {
    cookieConsent?: any;
    item?: any;
    settings?: any;
    user?: any;
}

export type ParentAction =
    | { type: "SET_PARENT_DATA"; payload: Payload }
    | { type: "CLEAR_PARENT_DATA" };

interface ParentState {
    cookieConsent?: any;
    item?: any;
    settings?: any;
    user?: any;
}

const initialState: ParentState = {
    cookieConsent: {},
    item: {},
    settings: {},
    user: {},
};

const parent = (state = initialState, action: ParentAction) => {
    switch (action.type) {
        case "SET_PARENT_DATA":
            return action.payload;
        case "CLEAR_PARENT_DATA":
            return initialState;
        default:
            return state;
    }
};
export default parent;
